import React, { useState } from 'react';
import { X, Send, Zap } from 'lucide-react';
import { emitNiwtAsk } from '../events';

interface Props {
  onClose: () => void;
}

const NIWTCO_AGENT_ID = 'niwtco-001';

const AskNiwtcoDrawer: React.FC<Props> = ({ onClose }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = () => {
    if (!query.trim()) return;
    emitNiwtAsk(NIWTCO_AGENT_ID);
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      handleSubmit();
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-40" onClick={onClose} />
      <div className="fixed right-0 top-0 h-full w-full max-w-[480px] bg-white z-50 shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-niwt-primary to-niwt-secondary flex items-center justify-center">
              <Zap className="w-3.5 h-3.5 text-white" />
            </div>
            <h2 className="text-sm font-semibold text-gray-900">Ask Niwtco</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 p-5 flex flex-col gap-4">
          <p className="text-xs text-gray-500">
            Ask Niwtco anything about your business. It will synthesize your team's knowledge and
            surface the most relevant information.
          </p>
          <textarea
            autoFocus
            rows={6}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="What would you like to know or do?"
            className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-niwt-primary placeholder-gray-400"
          />
          <p className="text-xs text-gray-400">Press ⌘↵ to submit</p>
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t border-gray-200">
          <button
            onClick={handleSubmit}
            disabled={!query.trim()}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-niwt-primary hover:bg-[#6B51A0] disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-medium rounded-xl transition-colors"
          >
            <Send className="w-4 h-4" />
            Ask
          </button>
        </div>
      </div>
    </>
  );
};

export default AskNiwtcoDrawer;
